module.exports = __webpack_public_path__ + "media/images/admin/icons/store_mall_directory-d6bc2ea0be9df0edf1efd40c24c92853.png";